import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { DividerSectionCms } from '~/cms/interfaces/homepage.cms.interface';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-cms-divider-section',
  templateUrl: './divider-section.component.html',
})
export class CmsDividerSectionComponent implements OnInit, OnDestroy {
  @Input() public section: DividerSectionCms;
  private readonly subscriptions = new Subscription();

  public isMobileDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get show(): boolean {
    return this.isMobileDevice
      ? this.section.visible_on_mobile_device
      : this.section.visible_on_desktop_device;
  }
}
